import { isPresent } from '@mbfab/shared'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'

const maintenanceStartAt: Dayjs | undefined = undefined
const maintenanceEndAt: Dayjs | undefined = undefined

export function isMaintenancePeriod({
  current = dayjs(),
  skipFlag = localStorage.getItem('skipMaintainance'),
  startAt = maintenanceStartAt,
  endAt = maintenanceEndAt,
}: {
  current?: Dayjs
  skipFlag?: string | null
  startAt?: Dayjs
  endAt?: Dayjs
} = {}): boolean {
  // QA でメンテナンス中の実画面を確認できるよう、旧 client と同じローカルフラグを維持する
  if (skipFlag === 'true') {
    return false
  }

  if (!isPresent(startAt) || !isPresent(endAt)) {
    return false
  }

  return current.isAfter(startAt) && current.isBefore(endAt)
}

export function MaintenanceScreen() {
  return (
    <main className="flex min-h-screen w-full items-center justify-center p-6 text-center text-muted-foreground">
      <p>
        現在メンテナンス中です。
        <br />
        メンテナンスの期間は{maintenanceStartAt?.format('YYYY年MM月DD日HH時')}〜
        {maintenanceEndAt?.format('YYYY年MM月DD日HH時') ?? ''}を予定しております。
        <br />
        ご迷惑をお掛け致しますが、何卒どうぞよろしくお願いします。
      </p>
    </main>
  )
}
